export default "__VITE_ASSET__Ukw1UL3x__"